/**
 * School Registration country options.
 * Values keep legacy numeric codes already stored in the DB.
 * India is intentionally omitted from the selectable list.
 */
export const COUNTRIES = [
  { value: "1", label: "United States" },
  { value: "2", label: "United Kingdom" },
  { value: "3", label: "Australia" },
  { value: "5", label: "Finland" },
  { value: "6", label: "Srila Lanka" },
];

/** Map Origin Master `origin` labels to country option values. */
export const ORIGIN_TO_COUNTRY_VALUE = {
  us: "1",
  "united states": "1",
  usa: "1",
  "united kingdom": "2",
  uk: "2",
  australia: "3",
  finland: "5",
  "sri lanka": "6",
};

export const US_COUNTRY_VALUE = "1";

export function isUnitedStatesCountry(value) {
  return String(value || "") === US_COUNTRY_VALUE;
}

export function resolveCountryOptions(originMasterOrigin, configs = []) {
  const list = Array.isArray(COUNTRIES) ? [...COUNTRIES] : [];
  const seen = new Set(list.map((c) => String(c.value)));

  const origins = [
    originMasterOrigin,
    ...(Array.isArray(configs) ? configs.map((c) => c?.origin) : []),
  ]
    .map((o) => String(o || "").trim())
    .filter(Boolean);

  for (const origin of origins) {
    const key = origin.toLowerCase();
    // Never add India back via Origin Master origin.
    if (key === "india" || key === "in") continue;
    const value = ORIGIN_TO_COUNTRY_VALUE[key];
    if (value && !seen.has(String(value))) {
      const match = COUNTRIES.find((c) => String(c.value) === String(value));
      if (match) {
        list.push(match);
        seen.add(String(value));
      } else {
        list.push({ value: String(value), label: origin });
        seen.add(String(value));
      }
    } else if (!value && origin && !list.some((c) => c.label.toLowerCase() === key)) {
      // Unknown Origin Master origin — surface it without hardcoding in the page.
      const dynamicValue = `origin:${origin}`;
      if (!seen.has(dynamicValue)) {
        list.push({ value: dynamicValue, label: origin });
        seen.add(dynamicValue);
      }
    }
  }

  return list.filter((c) => String(c.label || "").toLowerCase() !== "india");
}

export default COUNTRIES;
